export const useFieldPropertyVerification = (formFields) => {
  const verifyFieldProperty = ({ fieldName, fieldProperty }) =>
    formFields.find((field) => field.name === fieldName)?.[fieldProperty] ??
    fieldProperty === 'isHidden';

  return {
    verifyFieldProperty,
  };
};
